import React, { useEffect, useState } from 'react';

import Link from 'next/link';

import NewsletterSubscribeInput from '@/components/pages/frontpage/components/NewsletterSubscribeInput';
import subscribeToNewsletter, { NewsletterSubscription } from '@/utils/functions/subscribeToNewsletter';

const NewsletterPageLayout = () => {
    const [researchDailyChecked, setResearchDailyChecked] = useState(true);
    const [dailyChecked, setDailyChecked] = useState(true);
    const [subscribeTo, setSubscribeTo] = useState<NewsletterSubscription[]>([
        NewsletterSubscription.Daily,
        NewsletterSubscription.Weekly,
        NewsletterSubscription.ResearchDaily,
    ]);

    useEffect(() => {
        const updatedSubscribeTo: NewsletterSubscription[] = [];
        if (researchDailyChecked) {
            updatedSubscribeTo.push(NewsletterSubscription.ResearchDaily);
        }
        if (dailyChecked) {
            updatedSubscribeTo.push(NewsletterSubscription.Daily);
            updatedSubscribeTo.push(NewsletterSubscription.Weekly);
        }

        setSubscribeTo(updatedSubscribeTo);
    }, [researchDailyChecked, dailyChecked]);

    return (
        <div className="mx-auto pt-10 pb-20">
            <div className="flex gap-20 p-4">
                <div className="flex flex-col justify-center items-start gap-10 max-w-lg">
                    <div className="flex flex-col gap-5">
                        <div className="flex flex-col relative gap-3">
                            <p className="text-[40px] text-left text-[#110b29]">Newsletters</p>
                            <p className="text-2xl text-left text-[#5637cd]">
                                Understand the markets in just 5 minutes
                            </p>
                        </div>
                        <div className="flex justify-start items-center gap-5 w-full">
                            <NewsletterSubscribeInput
                                className="w-full"
                                inputPlaceholder={'Enter email address'}
                                buttonText={'Subscribe'}
                                onButtonClick={email => subscribeToNewsletter(email, subscribeTo)}
                            />
                        </div>
                    </div>
                    <div className="flex justify-center items-start self-stretch gap-4">
                        <div className="flex w-[25px] relative gap-2.5" onClick={() => setDailyChecked(!dailyChecked)}>
                            <svg
                                width="26"
                                height="25"
                                viewBox="0 0 26 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-[25px] h-[25px]"
                                preserveAspectRatio="none"
                            >
                                <rect
                                    x="0.869141"
                                    y="9.5"
                                    width="15"
                                    height="15"
                                    stroke="#B4B4B4"
                                    strokeOpacity="0.35"
                                ></rect>
                                {subscribeTo.includes(NewsletterSubscription.Daily) && (
                                    <path
                                        d="M9.52995 16.5365L5.1862 12.1927L3.70703 13.6615L9.52995 19.4844L22.0299 6.98437L20.5612 5.51562L9.52995 16.5365Z"
                                        fill="#5637CD"
                                    ></path>
                                )}
                            </svg>
                        </div>
                        <div className="flex flex-col justify-start items-start flex-grow gap-4">
                            <div className="flex flex-col justify-start items-start self-stretch relative gap-2">
                                <div className="flex w-[189px] relative gap-2.5">
                                    <p className="flex-grow w-[189px] text-2xl text-left text-[#110b29]">
                                        Blockworks Daily
                                    </p>
                                </div>
                                <p className="self-stretch text-base text-left text-[#110b29]">
                                    The daily newsletter that helps thousands of investors understand crypto and the
                                    markets, by Byron Gilliam.
                                </p>
                            </div>
                            <div className="flex justify-start items-center flex-grow-0 flex-shrink-0">
                                <div className="flex justify-start items-center relative gap-1">
                                    <Link href="/newsletter/daily" passHref>
                                        <a className="text-sm text-left uppercase text-[#5637cd]">see the archive</a>
                                    </Link>
                                </div>
                                <div className="flex flex-col justify-center items-center relative gap-2.5 pl-1 py-1">
                                    <svg
                                        width="9"
                                        height="4"
                                        viewBox="0 0 9 4"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="flex-grow-0 flex-shrink-0"
                                        preserveAspectRatio="none"
                                    >
                                        <path
                                            d="M6.37414 1.5H0.369141V2.5H6.37414V4L8.36914 2L6.37414 0V1.5Z"
                                            fill="#5637CD"
                                        ></path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-start items-start self-stretch gap-4">
                        <div
                            className="flex w-[25px] relative gap-2.5"
                            onClick={() => setResearchDailyChecked(!researchDailyChecked)}
                        >
                            <svg
                                width="26"
                                height="25"
                                viewBox="0 0 26 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-[25px] h-[25px]"
                                preserveAspectRatio="none"
                            >
                                <rect
                                    x="0.869141"
                                    y="9.5"
                                    width="15"
                                    height="15"
                                    stroke="#B4B4B4"
                                    strokeOpacity="0.35"
                                ></rect>
                                {subscribeTo.includes(NewsletterSubscription.ResearchDaily) && (
                                    <path
                                        d="M9.52995 16.5365L5.1862 12.1927L3.70703 13.6615L9.52995 19.4844L22.0299 6.98437L20.5612 5.51562L9.52995 16.5365Z"
                                        fill="#5637CD"
                                    ></path>
                                )}
                            </svg>
                        </div>
                        <div className="flex flex-col justify-start items-start flex-grow gap-4">
                            <div className="flex flex-col justify-start items-start self-stretch relative gap-2">
                                <div className="flex w-[189px] relative gap-2.5">
                                    <p className="flex-grow w-[189px] text-2xl text-left text-[#110b29]">
                                        Blockworks Research Daily
                                    </p>
                                </div>
                                <p className="self-stretch text-base text-left text-[#110b29]">
                                    Alpha directly in your inbox, including market highlights, charts, degen trade
                                    ideas, governance updates, token performance, can’t-miss-tweets and more, by
                                    Blockworks Research.
                                </p>
                            </div>
                            <div className="flex justify-start items-center flex-grow-0 flex-shrink-0">
                                <div className="flex justify-start items-center relative gap-1">
                                    <Link href="/newsletter/research" passHref>
                                        <a className="text-sm text-left uppercase text-[#5637cd]">see the archive</a>
                                    </Link>
                                </div>
                                <div className="flex flex-col justify-center items-center relative gap-2.5 pl-1 py-1">
                                    <svg
                                        width="9"
                                        height="4"
                                        viewBox="0 0 9 4"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="flex-grow-0 flex-shrink-0"
                                        preserveAspectRatio="none"
                                    >
                                        <path
                                            d="M6.37414 1.5H0.369141V2.5H6.37414V4L8.36914 2L6.37414 0V1.5Z"
                                            fill="#5637CD"
                                        ></path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="p-12 hidden lg:block">
                    <img
                        src="/images/newsletter/Phone_Newsletter.png"
                        // srcSet="/images/newsletter/newsletter-phone.png 1x, /images/newsletter/newsletter-phone@2x.png 2x, /images/newsletter/newsletter-phone@3x.png 3x"
                        className="h-[589px] object-cover"
                    />
                </div>
            </div>
        </div>
    );
};

export default NewsletterPageLayout;
